import * as ActionTypes from '../../actions/allActions'

const signUpInit = {
	first_name: "",
	last_name: "",
	email: "",
	password: "",
	password_confirmation: "",
	telephone: "",
	title: "",
	accept_cgu: false,
	accept_emails: false
}
const signup = (state = signUpInit, action) => {
	switch (action.type) {
		case ActionTypes.SIGNUP_DATACHANGE:
			return { ...state, ...action.changes }
		case ActionTypes.LOGOUT:
			return signUpInit
		default:
			return state
	}
}

export default signup


// WEBPACK FOOTER //
// ./src/reducers/data/signup.js